'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Chip } from '@common/components';
import { cn } from '@core/utils';
import useEmblaCarousel from 'embla-carousel-react';
import { CustomLink } from '@/app/_components/CustomLink';
import { DONATION_ROUTES } from '@/constants';
import { PERIOD_FILTER_OPTIONS } from '../constants';
interface PeriodFilterProps {
  period?: number;
}
export const PeriodFilter = t0 => {
  const $ = _c(9);
  const {
    period
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      align: "start",
      dragFree: true,
      containScroll: "trimSnaps"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [emblaRef] = useEmblaCarousel(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("mx-0 overflow-hidden pb-20", "mobile-tablet:p-20");
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== period) {
    t3 = PERIOD_FILTER_OPTIONS.map(t4 => {
      const {
        label,
        value
      } = t4;
      return <div key={value} className="w-fit flex-[0_0_auto] last-of-type:mr-20"><Button theme="sub-text" className="size-fit p-0" asChild={true}><CustomLink href={DONATION_ROUTES.MY_DONATIONS.withSearchParams({
            searchParams: {
              period: value
            }
          })} replace={true}><Chip theme="primary" className="h-38" checked={period === value}>{label}</Chip></CustomLink></Button></div>;
    });
    $[2] = period;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="flex gap-6">{t3}</div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== emblaRef || $[7] !== t4) {
    t5 = <div className={t2} ref={emblaRef}>{t4}</div>;
    $[6] = emblaRef;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};